import { useState } from "react";
import { toast } from "sonner";
import { LogOut, KeyRound, UserCircle2, X } from "lucide-react";
import { api } from "../lib/api";
import { formatApiError, useAuth } from "../lib/auth";

export const AccountMenu = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [pwOpen, setPwOpen] = useState(false);
  const [pw, setPw] = useState({ currentPassword: "", newPassword: "" });
  const change = async (e) => {
    e.preventDefault();
    try { await api.changePassword(pw); toast.success("Password changed — other sessions were signed out"); setPw({ currentPassword: "", newPassword: "" }); setPwOpen(false); }
    catch (ex) { toast.error(formatApiError(ex)); }
  };
  return (
    <div className="side-foot" style={{ position: "relative" }}>
      <button className="side-user" style={{ display: "flex", gap: 6, alignItems: "center", background: "none", border: 0, cursor: "pointer", width: "100%", textAlign: "left" }} onClick={() => setOpen(!open)} data-testid="account-menu-btn">
        <UserCircle2 size={16} /><span style={{ overflow: "hidden", textOverflow: "ellipsis" }} data-testid="current-user">{user?.email}</span><span className="badge" style={{ marginLeft: "auto", fontSize: 10, padding: "1px 7px" }} data-testid="current-role">{user?.role}</span>
      </button>
      {open && (
        <div className="card" style={{ position: "absolute", bottom: "100%", left: 8, right: 8, padding: 8, zIndex: 20 }} data-testid="account-menu">
          <button className="btn btn-ghost btn-sm" style={{ width: "100%", justifyContent: "flex-start" }} onClick={() => { setPwOpen(true); setOpen(false); }} data-testid="change-password-btn"><KeyRound size={14} /> Change password</button>
          <button className="btn btn-ghost btn-sm" style={{ width: "100%", justifyContent: "flex-start" }} onClick={logout} data-testid="logout-btn"><LogOut size={14} /> Sign out</button>
        </div>
      )}
      {pwOpen && (
        <>
          <div className="drawer-backdrop" onClick={() => setPwOpen(false)} />
          <form className="card" onSubmit={change} style={{ position: "fixed", top: "20%", left: "50%", transform: "translateX(-50%)", width: 360, zIndex: 50 }} data-testid="password-card">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}><div className="section-title" style={{ margin: 0 }}>Change password</div><button type="button" className="btn btn-ghost btn-sm" onClick={() => setPwOpen(false)} data-testid="pw-close"><X size={14} /></button></div>
            <label className="label">Current password</label><input className="input" type="password" value={pw.currentPassword} onChange={(e) => setPw({ ...pw, currentPassword: e.target.value })} required data-testid="pw-current" />
            <label className="label">New password (min 8)</label><input className="input" type="password" value={pw.newPassword} onChange={(e) => setPw({ ...pw, newPassword: e.target.value })} required minLength={8} data-testid="pw-new" />
            <button className="btn" style={{ marginTop: 16 }} type="submit" data-testid="pw-submit">Change password</button>
          </form>
        </>
      )}
    </div>
  );
};
